import React, { Component } from "react";
import InfoColumns from "./components/InfoColumns";
import SplashVideo from "./components/SplashVideo";
import ClientCarousel from "./components/ClientCarousel";
import CapabilitiesOverview from "./components/CapabilitiesOverview";
import WhoWeAre from "./components/WhoWeAre";
import { Visibility } from "semantic-ui-react";

class Home extends Component {
  onIconClick = () => {
    this.refs.info.scrollIntoView({behavior: "smooth"});
  };

  render() {
    return <div className="home-wrapper">
      {/* Visibility container for fixed navbar:
     *  The navbar appears at the top of the page, but once it has
     *  scrolled out of view, it will animate down from the top of the viewport,
     *  and remain fixed to the top of the viewport.
     */}
      <Visibility
        onBottomPassed={this.props.onBottomPassed}
        onBottomPassedReverse={this.props.onBottomPassedReverse}
        fixed={this.props.fixed}
        once={false}
      >
        <SplashVideo onClick={this.onIconClick}/>
      </Visibility>
      <div ref={"info"}/>
      <InfoColumns/>
      <WhoWeAre/>
      <ClientCarousel/>
      <CapabilitiesOverview/>
    </div>;
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js